// History Timeline Data
export const historyData = {
  title: "History of DC Early Childhood Education",
  subtitle: "The Development of the Pre-K Enhancement and Expansion Act of 2008",
  
  timeline: [
    {
      year: "1964",
      title: "Head Start Pilot Program",
      description: "Washington DC's Anacostia Pre-School Project serves as a pilot site for the Federal Head Start Program.",
      image: "https://images.pexels.com/photos/8364016/pexels-photo-8364016.jpeg",
      icon: "rocket"
    },
    {
      year: "1972",
      title: "Pre-K Pioneers",
      description: "Washington DC's Public Schools (DCPS) become one of the first jurisdictions in the country to offer pre-Kindergarten to four-year-old children.",
      image: "https://images.unsplash.com/photo-1761604478724-13fe879468cf?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
      icon: "flag"
    },
    {
      year: "1979",
      title: "MACECD Established",
      description: "The Mayor's Advisory Committee on Early Childhood Development (MACECD) is established to hold public hearings on early childhood education issues, increase public awareness, recommend methods of upgrading services, and improve communications between providers, the public and the government.",
      image: "https://images.unsplash.com/photo-1761208663763-c4d30657c910?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
      icon: "building"
    },
    {
      year: "1989",
      title: "COPE Report & Reform",
      description: "A report by the DC Committee on Public Education (COPE) calls attention to critical problems in DCPS. The report makes several recommendations for public school reform, including the need to expand and upgrade early childhood programs. In response, nearly 500 pre-K and kindergarten classrooms across the city are refurbished.",
      image: "https://images.pexels.com/photos/8612961/pexels-photo-8612961.jpeg",
      icon: "file-text"
    },
    {
      year: "1990",
      title: "DC Early Childhood Collaborative Founded",
      description: "A coalition of business, government and community organizations forms the DC Early Childhood Collaborative. The Collaborative pools public and private sector resources to improve the well-being of DC children and families. In 1993, the Collaborative establishes the Frederick Douglass Early Childhood Development and Family Support Center.",
      image: "https://images.unsplash.com/photo-1666891984308-7ffc3176c72b?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
      icon: "users"
    },
    {
      year: "2002",
      title: "Major National Grants",
      description: "Washington DC receives two major national grants: a $5 million, five-year award from The W.K. Kellogg Foundation to the National Black Child Development Institute (NBCDI) for the SPARK initiative, and an Early Learning Opportunities Act (ELOA) award from the U.S. Department of Education to the MACECD.",
      image: "https://images.unsplash.com/flagged/photo-1570319736696-894f69f52bd3?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
      icon: "award"
    },
    {
      year: "2003",
      title: "Universal School Readiness Stakeholder Group",
      description: "A group of more than 200 early childhood education and K-12 organizations come together to form the Universal School Readiness Stakeholder Group (USRSG). The USRSG becomes the 'umbrella' under which diverse groups work toward universal, high-quality pre-K.",
      image: "https://images.pexels.com/photos/8613089/pexels-photo-8613089.jpeg",
      icon: "book-open"
    },
    {
      year: "2004",
      title: "Road Map to Universal School Readiness",
      description: "Under the banner of the USRSG, early childhood education advocates develop the Road Map to Universal School Readiness, which becomes a seminal document in the movement to develop high-quality, universal pre-K programming.",
      image: "https://images.pexels.com/photos/8538362/pexels-photo-8538362.jpeg",
      icon: "map"
    },
    {
      year: "2005",
      title: "Pre-K Incentive Program",
      description: "DCPS grants $4.6 million to the Department of Human Services-Early Care and Education Administration to provide high-quality pre-K programs in community-based settings. These dollars fund the Pre-K Incentive Program, which operates 20 high-quality pre-K centers across DC.",
      image: "https://images.unsplash.com/photo-1747069340204-3a62a3666271?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
      icon: "dollar-sign"
    },
    {
      year: "2006",
      title: "Pre-K for All DC Campaign Launched",
      description: "The Pre-K for All DC Campaign is launched with funding from Pre-K Now and the CityBridge Foundation. The Campaign raises additional funding from the DC Early Childhood Collaborative, PNC Bank and other private sources. Pre-K for All DC is housed at the National Black Child Development Institute.",
      image: "https://images.unsplash.com/photo-1759678444821-565ff103465c?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
      icon: "megaphone"
    },
    {
      year: "2007",
      title: "Legislative Framework Development",
      description: "DC Council Chair Vincent Gray asks Pre-K for All DC to work with him to develop pre-K for all legislation. The Campaign Steering Committee forms a legislative policy sub-committee and begins drafting a legislative framework.",
      image: "https://images.pexels.com/photos/8613083/pexels-photo-8613083.jpeg",
      icon: "edit"
    },
    {
      year: "2008",
      title: "Public Hearing for Bill 17-537",
      description: "Pre-K for All DC organizes a public hearing at the DC Council for Bill 17-537/The Pre-K for All DC Amendment Act of 2007. Testimony is heard from 60 people, including local early childhood education advocates, national early learning experts, city officials, parents, and members of the DC business community.",
      image: "https://images.unsplash.com/photo-1697906098861-f4badecb4af9?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
      icon: "mic"
    },
    {
      year: "May 2008",
      title: "Pre-K Enhancement and Expansion Act Passes",
      description: "The DC Council unanimously passes the Pre-K Enhancement and Expansion Act of 2008. The Act expands pre-K to serve approximately 2000 three- and four-year-olds who do not have access to programming. The law also provides resources and support to improve the quality of pre-K programs and assist individuals in obtaining credentials to serve as teachers.",
      image: "https://images.unsplash.com/photo-1628198661856-102874fb9d82?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
      icon: "check-circle"
    }
  ]
};
